/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/mediusFlowMigrationRest"/>
import { toAction } from "../lib/path";
import { ajax as ajaxRawCall } from "../lib/ajax";

function ajaxCall(
    service: string,
    resource: string | number,
    options: JQueryAjaxSettings = {},
    signal: AbortSignal = undefined,
    httpMethod: string = undefined,
    forceCache: boolean = true) {

    const settings = { ...options };
    if (httpMethod)
        settings.type = httpMethod;
    if (forceCache)
        settings.cache = true;

    const uri = createUrl(service, resource);
    return ajaxRawCall(uri, settings, signal);
}

export function createUrl(service: string, resource?: string | number) {
    const url = `${toAction("mediusflow", "~/remedium-api")}/${service}`;
    return resource || resource === 0
        ? `${url}/${resource}`
        : url;
}

/* @deprecated */
export function ajax(service: string, resource: string | number, options?: JQueryAjaxSettings, signal?: AbortSignal) {
    return ajaxCall(service, resource, options, signal);
}

export function get(service: string, resource?: string | number, options?: JQueryAjaxSettings, signal?: AbortSignal) {
    return ajaxCall(service, resource, options, signal, "GET", false);
}

export function post(service: string, resource: string | number, options?: JQueryAjaxSettings, signal?: AbortSignal) {
    return ajaxCall(service, resource, options, signal, "POST");
}

export function put(service: string, resource: string | number, options?: JQueryAjaxSettings, signal?: AbortSignal) {
    return ajaxCall(service, resource, options, signal, "PUT");
}

export function del(service: string, resource: string | number | undefined, options?: JQueryAjaxSettings, signal?: AbortSignal) {
    return ajaxCall(service, resource, options, signal, "DELETE");
}
